import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import AlertSection from '../alert-section/alert-section.component'

const IntroOffersAlert = ({ location }) => {
  const { t } = useTranslation(['checkIn'])

  return <AlertSection type="introOffers" title={t('checkIn:introOffer')} description={location} />
}

IntroOffersAlert.propTypes = {
  location: PropTypes.string,
}

export default IntroOffersAlert
